export enum DeviceManagementArtifactType {
  SwPackage = 'SW_PACKAGE',
  Template = 'TEMPLATE',
}

export enum DeviceManagementArtifactComponentType {
  SystemPackage = 'SYSTEM_PACKAGE',
  Application = 'APPLICATION',
  OS = 'OS',
  Other = 'OTHER',
  Resource = 'RESOURCE',
}

export declare const deviceManagementArtifactComponentType: {
  readonly APPLICATION: 'APPLICATION';
  readonly OS: 'OS';
  readonly OTHER: 'OTHER';
  readonly RESOURCE: 'RESOURCE';
  readonly SYSTEM_PACKAGE: 'SYSTEM_PACKAGE';
};
export type DeviceManagementArtifactComponentTypeApi =
  (typeof deviceManagementArtifactComponentType)[keyof typeof deviceManagementArtifactComponentType];

export declare const deviceManagementArtifactType: {
  readonly SW_PACKAGE: 'SW_PACKAGE';
  readonly TEMPLATE: 'TEMPLATE';
  readonly DATA_FILE: 'DATA_FILE';
};
export type DeviceManagementArtifactTypeApi =
  (typeof deviceManagementArtifactType)[keyof typeof deviceManagementArtifactType];

export interface DeviceManagementArtifact {
  readonly checksum: string;
  readonly id: string;
  readonly name: string;
  readonly size: number;
  readonly componentType: DeviceManagementArtifactComponentTypeApi;
  readonly createdBy: string;
  readonly creationDate: Date;
  readonly mimeType: string;
  readonly targetLocation?: string;
  readonly templateFileId?: string;
  readonly templateFileVersion?: string;
  readonly templateFileName?: string;
  readonly type: DeviceManagementArtifactTypeApi;
}

export interface DeviceManagementArtifactResponse {
  readonly pagination: {
    readonly itemsPerPage?: number;
    readonly startIndex?: number;
    readonly totalResults?: number;
  };
  readonly data: DeviceManagementArtifact[];
}
